import Page from './page'
export default {
  install: function (Vue) {
    Vue.component('page', Page)
  }
}
